import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { LicenseSnapshot } from "@/types";

// #254: redigierter Lizenz-Status. Pollt periodisch, damit State-Wechsel (Refresh-Loop,
// Portal-Widerruf, Grace-Ablauf) in der UI sichtbar werden.
export function useLicense(): UseQueryResult<LicenseSnapshot> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: queryKeys.list("license"),
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<LicenseSnapshot>("/license");
    },
    enabled: !!session,
    refetchInterval: 30_000,
  });
}
